export const getCountryFlag = (countryCode = '') => {
  const normalizedCode = countryCode.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(normalizedCode)) {
    return '🌐';
  }

  return String.fromCodePoint(
    ...normalizedCode.split('').map((character) => 127397 + character.charCodeAt(0)),
  );
};
